<div class="chart-value d-flex radius-15">
  <div *ngFor="let site of data" class="site-value">
    <div class="site-content">
      <span>{{ site?.label }}</span>
      <p class="paragraph-text">{{ site?.value || 0 }}</p>
    </div>
  </div>
</div>